export default "__VITE_ASSET__e6b8cd95__"